import { Box, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { monthlyCharge } from '.'
import { SvgImage } from '../../comps/SvgImage'
import { Colors, dateFormatter, DateFormatTypes, getDateTimeToDDMMMYYYY } from '../../util/util'

const DeviceDetails = ({ data = {}, onCancel }: any) => {
  const { tid, dsn, vpa, activatedOn, onTimeSetUpFee, todaysSuccessfulTxnsAmt }: any = data?.details ?? {}
  const fee = monthlyCharge(onTimeSetUpFee)

  const date = activatedOn
  let dateWithAmPm: any = null
  if (date) {
    try {
      dateWithAmPm = dateFormatter(date, DateFormatTypes.DATE_AM_PM)
      dateWithAmPm = getDateTimeToDDMMMYYYY(dateWithAmPm, false)
    } catch (error) {
      dateWithAmPm = null
      console.log('failed to parse date', error)
    }
  }
  let dataMap = [
    {
      label: 'TID',
      value: tid ?? 'NA',
    },
    {
      label: 'DSN',
      value: dsn ?? 'NA',
    },
    {
      label: 'VPA',
      value: vpa ?? 'NA',
    },
    {
      label: 'Activated on',
      value: dateWithAmPm ?? 'NA',
    },
    {
      label: 'One time setup charge',
      value: fee ? `₹${fee}` : '₹0.00',
    },
  ]

  if (todaysSuccessfulTxnsAmt !== null) {
    dataMap?.splice(3, 0, {
      label: 'Today’s Collection',
      value: todaysSuccessfulTxnsAmt ? `₹${monthlyCharge(todaysSuccessfulTxnsAmt)}` : '₹0.00',
    })
  }

  return (
    <>
      <Box borderTopLeftRadius={30} borderTopRightRadius={30} bg="WHITE" overflow={'hidden'} p={25}>
        <Spacer size={10} direction="vertical" />
        <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={20}>
          <Box width={'90%'}>
            <Text fontFamily="JioType-Black" fontSize={24}>
              Device Details
            </Text>
          </Box>
          <Box onPress={() => onCancel(false)} testID="close" underlayColor={'TRANSPARENT'}>
            <SvgImage imageName="Close" />
          </Box>
        </Box>
        <Spacer size={10} direction="vertical" />

        <Box flexDirection={'column'}>
          {dataMap?.map((item, index) => {
            if (!item?.value) {
              return null
            }
            return (
              <ModBox
                key={index}
                show={item?.value}
                flexDirection={'row'}
                marginVertical={15}
                justifyContent={'space-between'}>
                <Box flex={1}>
                  <Text fontFamily="JioType-Medium" fontSize={14} color={Colors.PRIMARY_GREY as ColorOptions}>
                    {item?.label}
                  </Text>
                </Box>
                <Box flex={1} alignSelf={'flex-start'}>
                  <Text fontFamily="JioType-Medium" fontSize={14} color={'BLACK_21'}>
                    {item?.value}
                  </Text>
                </Box>
              </ModBox>
            )
          })}
        </Box>
      </Box>
    </>
  )
}

export default DeviceDetails
